import type { MessagingGetChatMessages200Page } from './messagingGetChatMessages200Page';

/**
 * 채팅 메시지 목록 응답 데이터
 */
export type MessagingGetChatMessages200 = {
  code?: string;
  message?: string;
  page?: MessagingGetChatMessages200Page;
  success?: boolean;
};
